import React from 'react'

export const Services = (prop) => {
    const service=[
        {
            id:1,
            img:`./Assets/img/agile.webp`,
            iconbox:`./Assets/icons/cogwheel.png`,
            heading:`Commercial Service`,
            para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:2,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:3,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:4,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:5,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:6,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:7,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:8,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:9,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:10,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:11,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:12,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:13,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:14,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:15,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:16,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:17,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:18,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
    {
        id:19,
        img:`./Assets/img/agile.webp`,
        iconbox:`./Assets/icons/cogwheel.png`,
        heading:`Commercial Service`,
        para:`Lorem ipsum dolor sit amets consec of tetur adipisicing elit sed do eiusmod tempor`,
    },
]
  return (
   <section className='services m-btm' id='service'>
          <div className="container">
          <div className="heading-box flex  spce-btwn">
                      <div className="heading">
                            <span className="title">Our Services</span>
                            <h2>Services We Provide</h2>
                      </div>
                     <div className="visit-btn">
                         <a href="/" className="glbl-btn">View All services</a>
                     </div>
                </div>
              <div className="flex spce-btwn">
                   {
                       service.map((serEl, index)=>{
                        if(index<prop.activeCardSer){
                             return(
                                <div className="service-box" key={serEl.id}>
                                <div className="img-part">
                                     <img src={serEl.img} alt="service"  className='img-fluid'/>
                                </div>
                                <div className="contant-part">
                                     <div className="icon-box">
                                         <img src={serEl.iconbox} alt="services"/>
                                     </div>
                                    <h3>{serEl.heading}</h3>
                                    <p>{serEl.para}</p>
                                    <a href="/" className='glbl-btn'>Read More</a>
                                </div>
                           </div>
                             )
                        }
                             else{
                                        
                            }
                       })
                   }
              </div>
          </div>
   </section>
  )
}
